var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74443 31.193C23.5775 5.55005 50.1441 -6.77187 68.0765 3.77392L101.838 23.2004L96.4142 47.7332C95.0859 45.9571 93.5362 44.403 91.5437 43.2929C81.3598 37.4094 66.4161 44.292 58.0033 58.834C49.5906 73.2651 51.0296 89.8054 61.2135 95.6888C68.7407 100.129 79.0352 97.3539 87.3373 89.5834L49.0371 116.225C49.0371 116.225 12.9508 95.6888 12.508 95.1338C-0.885962 80.1476 -5.53512 55.8368 8.74443 31.193Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.444 88.6819C123.208 63.038 120.628 33.8254 102.68 23.4336C84.7324 13.0419 58.2145 25.4062 43.4504 51.0501C28.6864 76.694 31.2671 105.907 49.2147 116.298C67.1623 126.69 93.6803 114.326 108.444 88.6819Z",
    fill: "#2797E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7676 75.2633L72.6156 85.254L92.2085 58.168",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 47.1292,
    y1: 0.463541,
    x2: 57.2229,
    y2: 115.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2797E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1449D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.dde3e1b0.svg";
export { ForwardRef as ReactComponent };